import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';

export default function updateProjectPlan(rb: RequestBuilder, entity: string, multiSelect: MultiSelect): Promise<any> {
	return new Promise<any>(resolve => {
		openModal('MultiUpdateProjectPlan', {
			filters: rb,
			entity,
			multiSelect,
			onClose: resolve
		});
	});
}
